import React from 'react';
import { CodeTab as DagCodeTab } from '../../dag-detail/code-tab';

type CodeTabProps = {
    dagId: string;
    refreshKey: number;
};

/*
 * Thin wrapper reusing the DAG detail Code tab, scoped to this task instance's DAG
 */
export function CodeTab({ dagId, refreshKey }: CodeTabProps) {
    return <DagCodeTab dagId={dagId} details={null} isLoadingDetails={false} refreshKey={refreshKey} />;
}
